<app-header *ngIf="showHeader"></app-header>
<app-sidebar *ngIf="showSidebar"></app-sidebar>
<div class="air-content-base" id="contentBase" [ngClass]="{'air-console-content': showSidebar}">
    <router-outlet></router-outlet>
</div>

